import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link, useLocation } from "react-router-dom";
// material ui
import { makeStyles } from "@mui/styles";
import {
  Box,
  Grid,
  InputLabel,
  MenuItem,
  FormControl,
  FormHelperText,
  Select,
  IconButton,
  TextField
} from "@mui/material";
// icons
import SettingsIcon from "@mui/icons-material/Settings";
// import EditDocumentIcon from '@mui/icons-material/EditDocument';
import EditNoteIcon from '@mui/icons-material/EditNote';
import CloseIcon from "@mui/icons-material/Close";
import SummarizeIcon from "@mui/icons-material/Summarize";
import HelpIcon from "@mui/icons-material/Help";
import PreviewIcon from '@mui/icons-material/Preview';
import CancelIcon from "@mui/icons-material/Cancel";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import DeleteIcon from "@mui/icons-material/Delete";
import EmailEditor from "react-email-editor";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Alert, AlertTitle, Chip } from "@mui/material";
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
} from "@mui/material";
// components
import Layout from "../../layout/Layout";
import { HeaderDropDown } from "../../components/common/HeaderDropdown";
import { assessmentTypes } from "../../components/common/staticTemplate";
import {
  MuiDataGrid,
  GridCellExpand,
  ModalPopUp,
  FormSubmitButton,
  MyTextInput,
  Notifier,
  MuiAutocomplete,
  ErrorNotifier,
  ModalCloseBtn,
  ConfirmDialog,
  MuiTooltip,
  PageHeader,
  CommonCurdPopUp,

} from "../../components";

import { Stack } from "@mui/material";
// icons


// redux

import {
  createEmailAssessmentTemplate, updateEmailUpdateTemplate, deleteEmailTemplate, getAssessmentEmailTemplate, resetErrMessage,
  resetMessage, setErrorMessage, rowSelect, getEmailAssessmentTemplateByCustomerAccounts
} from "../../features/prepare_assessments/prepareAssessmentSlice";

import { getAccount, getAccountById } from "../../features/customer/accountSlice";
import { getCustomer } from "../../features/customer/customerSlice";


import { getPlatformStatus } from "../../features/config/platformStatusSlice";
import { getTemplateType } from "../../features/config/templateType";
// import { ConfirmDialog } from "../../../../components";
// import MicrositeConfirmDialog from "../../customer_management/microsites/MicrositeConfirmDialog";
import { TurnLeftOutlined } from "@mui/icons-material";
import { textAreaChecker, textChecker } from "../../components/common/form_validation/regularExpressions";
import { textAreaFieldErr, textFieldErr } from "../../components/common/form_validation/validationErrMessages";
import { getassessmentEmailType, getassessmentType, setAssessmentType } from "../../features/config/assessmentTypeSlice";
import { values } from "lodash";


// ------------------------------------------------------------------------------

const validationSchema = Yup.object({
  // templateDisplayName: Yup.string().required(
  //   "Template Display Name is required"
  // ).matches(textChecker, textFieldErr),
  custName: Yup.object().nullable().required("Customer Name is required"),
  account: Yup.object().nullable().required("Account Name is required"),
  standardTemplate: Yup.object().required("Standard Template is required"),
  templateCategory: Yup.object().nullable().required("Template Category is required"),

  // description: Yup.string()
  //   .max(500, "Description must be at most 500 characters")
  //   .required("Description is required").matches(textAreaChecker, textAreaFieldErr),

});

const editValidationSchema = Yup.object({
  // templateDisplayName: Yup.string().required(
  //   "Template Display Name is required"
  // ).matches(textChecker, textFieldErr),

  status: Yup.string().required("Status is required"),
  description: Yup.string().nullable()
    .max(500, "Description must be at most 500 characters")


});

// -------------------------------------------------------------------------

const style = {
  position: "absolute",
  top: "50%",
  left: "60%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "5px",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
};

const useStyles = makeStyles((theme) => ({
  rootbox: {
    position: "absolute !important",
    top: "50% !important",
    left: "60% !important",
    transform: "translate(-50%, -50%) !important",
    width: "56.25rem !important",
    [theme.breakpoints.down("sm")]: {
      width: "17.75rem !important",
      height: "44% !important",
      // display:'block !important',
      // overflow:'scroll !important',
      marginTop: "-8.25rem",
      marginLeft: "-0.938rem",
    },
    [theme.breakpoints.between("sm", "md")]: {
      width: "24.375rem  !important",
      height: "34% !important",
      display: "block !important",
      overflow: "scroll !important",
      // margin: '-3.188rem',
      marginTop: "-3.75rem  !important",
      marginLeft: "-3.563rem",
      padding: "2.125rem !important",
    },
    background: "#fff !important",
    borderRadius: "0.313rem !important",
    boxShadow: "1.5rem !important",
    paddingTop: "1rem !important",
    paddingLeft: "2rem !important",
    paddingRight: "2rem !important",
    paddingBottom: "1.5rem",
    display: "flex !important",
    flexDirection: "column !important",
    justifyContent: "center !important",
    alignItems: "center !important",
  },

  responsive_text: {
    width: "50rem",
    [theme.breakpoints.down("md")]: {
      width: "13rem",
    },
  },
}));
// ------------------------------------------------------------------------

const AssessmentTemplateConfig = (props) => {
  const [showAdd, setShowAdd] = useState(false);
  const [previewEmail, setPreviewEmail] = useState(false);
  const [previewEmailTemplate, setPreviewEmailTemplate] = useState(false);

  const [assessmentCategory, setAssessmentCategory] = useState(null)
  const [showAdd2, setShowAdd2] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selectedCustValue, setSelectedCustValue] = useState(null)
  const [selectedAccountValue, setSelectedAccountValue] = useState(null)
  const [htmlPreview, setHtmlPreview] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [forceDelConfirmDialog, setForceDelConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [copyLoading, setCopyLoading] = useState(false);

  const dispatch = useDispatch();
  const emailEditorRef = useRef(null);
  const htmlRef = useRef(null);
  const location = useLocation();


  //useselector from redux store

  const { assessmentFrameworkConfigData, loading } =
    useSelector((state) => ({ ...state.assessmentFrameworkConfig }));

  const { message, errMessage, assessmentEmailTemplateData, selectedData } =
    useSelector((state) => ({ ...state.prepareAssessment }));

  const { assessmentTemplateStatusData } = useSelector((state) => ({
    ...state.assessmentTemplateStatus,
  }));
  const { assessmentTypeData, assessmentEmailData, assessmentType } = useSelector((state) => ({
    ...state.assessmentTypeConfig,
  }));

  const { customerValue, accountValue } = useSelector((state) => ({
    ...state.auth,
  }));

  const { accountData, accountIdData,selectedAccountDataList, selectedCustomerDataList } = useSelector((state) => ({ ...state?.account }));
  const { customersData } =
    useSelector((state) => ({ ...state.customer }));

  const { TemplateTypeData } = useSelector((state) => ({
    ...state.assessmentTemplateType,
  }));

  const { permissionsData } = useSelector((state) => ({
    ...state.permissions,
  }));



  const showAddModel = () => {
    setShowAdd2(!showAdd);
  };

  //reset method for reseting the field values
  const closeModel = () => {
    setShowAdd2(false);
    const { account, custName, } = formik?.values

    formik.resetForm({
      values: {
        account: selectedAccountValue ? account : null,
        custName: selectedCustValue ? custName : null,
        templateCategory: assessmentCategory
      },
    });
    // dispatch(getassessmentType())
  };
  // function getTemplateTypeName(params) {

  //   return params?.row?.templateTypeName &&
  //     params?.row?.templateTypeName.toLowerCase() == "standard"
  //     ? "Standard" : params?.row?.templateTypeName.toLowerCase() == "talent" ? "Client"
  //     : params?.row?.templateTypeName;
  // }

  function getTemplateTypeName(value,  params) {
    const templateTypeName = params?.assessmentType;
    return templateTypeName;
  }

  const showEditModal = () => {
    setShowEdit(true);
  };

  const closeEditModal = () => {
    setShowEdit(false);
  };




  // Load Initial Design in the Modal
  const onLoad = () => {

    //   const style = document.createElement("style");

    //   style.innerHTML = `
    //   .blockbuilder-tools-device {
    //     display: none !important;
    //   }

    //   .blockbuilder-preview-toggle {
    //     display: none !important;
    //   }

    //   .blockbuilder-top-row {
    //     display: none !important;
    //   }
    // `;

    //   document.head.appendChild(style);

    try {
      const parsedData = JSON.parse(
        selectedData?.blocksJson || "{}"
      );
      // New templates
      if (parsedData.design) {
        emailEditorRef.current.editor.loadDesign(
          parsedData.design
        );
        return;
      }

      // Old templates fallback
      const htmlContent = parsedData.html || "";




      const subject = selectedData?.masterTemplate?.subject || "";
      const subjectStyle = `
      text-align:center;
      font-size:16px;
      font-family:Arial,sans-serif;
      font-weight:bold;
      margin:0;`;

      const subjectContent = `
  <p style="${subjectStyle}">
    Subject: ${subject}
  </p>
     `;

      // const parser = new DOMParser();
      // const doc = parser.parseFromString(selectedData?.masterTemplate?.preview, "text/html");

      // const bodyContent = doc.body.innerHTML;
      // console.log(doc.body.innerHTML)
      console.log(selectedData?.masterTemplate?.preview)

      //       const bodyContent = selectedData?.masterTemplate?.preview.replace(
      //   /<p(?![^>]*style=)/gi,
      //   '<p style="margin:16px 0; line-height:1.5;"'
      // );
      // const bodyContent = selectedData?.masterTemplate?.preview
      // .replace(
      //   /<p([^>]*)>/gi,
      //   '<div$1 style="margin:16px 0;">'
      // )
      // .replace(
      //   /<\/p>/gi,
      //   '</div>'
      // );
      //       const match = selectedData?.masterTemplate?.preview.match(
      //   /<body[^>]*>([\s\S]*)<\/body>/i
      // );



      // const bodyContent = match ? match[1] : selectedData?.masterTemplate?.preview;
      // const bodyContent = selectedData?.masterTemplate?.preview
      // .replace(
      //   /<p(?![^>]*style=)/gi,
      //   '<p style="margin:16px 0; line-height:1.5;"'
      // );

      const bodyContent = selectedData?.masterTemplate?.preview.replace(
        /<\/p>/gi,
        "</p><p>&nbsp;</p>"
      );



      const template = {
        body: {
          values: {
            contentWidth: "600px",
          },
          rows: [
            {
              cells: [1],
              columns: [
                {
                  contents: [
                    {
                      type: "text",
                      values: {
                        containerPadding: "0px",
                        text: subjectContent,


                      },
                    },
                    {
                      type: "text",
                      values: {
                        containerPadding: "0px",
                        text:
                          htmlContent || bodyContent || ""
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      };




      emailEditorRef.current.editor.loadDesign(template);
      setTimeout(() => {
        emailEditorRef.current.editor.exportHtml((data) => {
          console.log("=== AFTER LOAD ===");
          console.log(data.html);
        });
      }, 3000);
    } catch (err) {
      console.error("Failed to load template", err);
    }
  };


  //exporting html 
  const exportHtml = () => {
    const editor = emailEditorRef.current.editor;

    editor.exportHtml((data) => {
      const { html } = data;

      console.log("HTML:", html);

      setHtmlPreview(html);
    });
  };

  // Save Design to and calling backedn Api 
  const saveDesign = () => {

    const editor = emailEditorRef.current.editor;

    editor.saveDesign((design) => {
      editor.exportHtml((data) => {
        let { html } = data;



        const missingFields = selectedData?.masterTemplate?.params?.filter(
          (param) => !html.includes(`${param.sample}`)
        );

        //   const missingFieldsInSubject = selectedData?.masterTemplate?.params?.filter(
        //   (param) => !html.includes(`${param.sample}`)
        // );

        if (missingFields?.length > 0) {
          dispatch(
            setErrorMessage(
              `Required dynamic fields are missing: ${missingFields
                .map((x) => x.sample)
                .join(", ")}`
            )
          )
          setTimeout(() => {
            dispatch(resetErrMessage());
          }, 2000);


          return;
        }

        selectedData?.masterTemplate?.params.forEach((params) => {
          const regex = new RegExp(
            params.sample?.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
            "g"
          );

          html = html.replace(regex, `{{${params.key}}}`);

        });


        //  selectedData?.masterTemplate?.params?.forEach((param) => {
        //   console.log()
        //   html = html.replaceAll(
        //     param.sample,
        //     `{${param.key}}`
        //   );
        // });

        html = html.replace(
          /<p([^>]*)style="([^"]*)"/gi,
          '<p$1style="$2;margin-top:0;margin-bottom:0;"'
        );



        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        // Get subject text
        const allParagraphs = doc.querySelectorAll("p");

        let heading = "";

        allParagraphs.forEach((p) => {
          const text = p.textContent?.trim();

          if (text?.startsWith("Subject:")) {
            heading = text.replace("Subject:", "").trim();
            p.style.display = "none";
          }
        });



        selectedData?.masterTemplate?.subjectParams?.forEach((param) => {
          if (
            param.sample &&
            heading.includes(param.sample)
          ) {
            heading = heading.replaceAll(
              param.sample,
              `{{${param.key}}}`
            );
          }
        });

        console.log(heading);




        // Remove subject heading from HTML
        // if (subjectElement) {
        //   subjectElement.remove();
        // }


        // Get cleaned HTML
        html = doc.body.innerHTML;

        const body = {
          id: selectedData?.id,
          masterTemplateId:
            selectedData?.masterTemplate?.masterTemplateId,

          // Recommended structure
          blocksJson: JSON.stringify({
            design,
            html,
          }),

          subject: heading,
        };

        dispatch(updateEmailUpdateTemplate(body)).then((res) => {
          if (res?.payload?.data?.ok) {
            setTimeout(() => {
              dispatch(resetMessage());
              setPreviewEmailTemplate(false);
              setPreviewEmail(false);

              selectedCustValue && !selectedAccountValue ?
                dispatch(getEmailAssessmentTemplateByCustomerAccounts({ assessmentCustomerId: selectedCustValue?.id }))
                : selectedAccountValue
                  ? dispatch(getEmailAssessmentTemplateByCustomerAccounts({ assessmentCustomerId: selectedCustValue?.id, assessmentCustomerAccountId: selectedAccountValue?.id }))
                  : dispatch(getAssessmentEmailTemplate());

            }, 2000);

            return true;
          }

          if (res?.payload?.error) {
            setTimeout(() => {
              dispatch(resetErrMessage());
            }, 3000);
          }

          return false;
        });
      });
    });
  };


  // const dynamicFields = {
  //   "Full Name": "{}",
  //   "Email Address": "{{email}}",
  //   "Assessment Name": "{{assessmentName}}",
  //   "Assessment Date": "{{assessmentDate}}",
  // };

  // Object.entries(dynamicFields).forEach(([label, variable]) => {
  //   const regex = new RegExp(label, "gi");
  //   html = html.replace(regex, variable);
  // });





  //method for showing the delete modal

  const showDelete = () =>
    setConfirmDialog({
      isOpen: true,
      title: "Are you sure to delete this record?",
      subTitle: "You can't undo this operation",
      onConfirm: () => handleDeleteEmailTemplate(),
    });


  //deleting the email template
  const handleDeleteEmailTemplate = () => {
    let data = {
      id: selectedData?.id,
    };
    dispatch(deleteEmailTemplate(data)).then((res) => {
      if (res?.payload?.data?.ok) {
        setTimeout(() => {
          dispatch(resetMessage());
          setConfirmDialog({
            ...confirmDialog,
            isOpen: false,
          });
          selectedCustValue && !selectedAccountValue ?
                dispatch(getEmailAssessmentTemplateByCustomerAccounts({ assessmentCustomerId: selectedCustValue?.id }))
                : selectedAccountValue
                  ? dispatch(getEmailAssessmentTemplateByCustomerAccounts({ assessmentCustomerId: selectedCustValue?.id, assessmentCustomerAccountId: selectedAccountValue?.id }))
                  : dispatch(getAssessmentEmailTemplate());

        }, 2000);
      }
      if (res?.payload?.error) {
        setTimeout(() => {
          dispatch(resetErrMessage());
        }, 3000);
      }
    });
  };



  const handleSetConfirmDialog = (obj) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: obj.isOpen,
    });
  };


  const getCustomerSelectedValue = (data) => {
    formik.setFieldValue("custName", data)
    setSelectedCustValue(data)
  }

  const getAccountSelectedValue = (data) => {
    formik.setFieldValue("account", data)
    setSelectedAccountValue(data)
  }


  const classes = useStyles();

  function renderCellExpand(params) {
    return (
      <GridCellExpand
        value={params?.value || ""}
        width={params?.colDef.computedWidth}
      />
    );
  }



  //datagrid for showing the email template records

  const data = {
    rows: assessmentEmailTemplateData?.length > 0
      ? assessmentCategory ? assessmentEmailTemplateData?.filter((data) => data.templateCategory === assessmentCategory?.name) : assessmentEmailTemplateData
      : [],
    columns: [
      {
        field: "customer",
        headerName: "Customer Name",
        width: 200,
        valueGetter: (value,  params) => params?.assessmentCustomer?.customerName,

        // renderCell: renderCellExpand,
      },
      {
        field: "account",
        headerName: "Account Name",
        width: 200,
        valueGetter: (value,  params) => params?.assessmentCustomerAccount?.accountName,

        // renderCell: renderCellExpand,
      },
      {
        field: "templateName", headerName: "Template Name", valueGetter: (value,  params) => params?.
          masterTemplate?.templateName, width: 250
      },
      {
        field: "preview",

        // headerName: 'Actions',
        type: "actions",
        width: 50,
        renderCell: (params) => {

          return (
            <MuiTooltip title="Preview Template" placement="right">

              <IconButton aria-label="preview" onClick={() => {
                setPreviewEmail(true)
                dispatch(rowSelect([params?.row]))
              }} sx={{ p: 0 }}>
                <PreviewIcon color="primary" />
              </IconButton>

            </MuiTooltip>
          );
        },
      },
      {
        field: "edit",

        // headerName: 'Actions',
        type: "actions",
        width: 50,
        renderCell: (params) => {

          return (
            <MuiTooltip title="Edit Template" placement="right">

              <IconButton aria-label="edit" onClick={() => {
                setPreviewEmailTemplate(true)
                dispatch(rowSelect([params?.row]))
              }} sx={{ p: 0 }}>
                <EditNoteIcon color="primary" />
              </IconButton>

            </MuiTooltip>
          );
        },
      },
      { field: "status", headerName: "Status", width: 150, renderCell: renderCellExpand },
      {
        field: "category", valueGetter: (value,  params) => params?.
          masterTemplate?.variableName, headerName: "Template Type", width: 250
      },
      {
        field: "variableName", valueGetter: (value,  params) => params?.templateCategory
        , headerName: "Template Category", width: 200, renderCell: renderCellExpand
      },

      { field: "description", headerName: "Comments", width: 250, renderCell: renderCellExpand },

      // {
      //   field: "copy",

      //   // headerName: 'Actions',
      //   type: "actions",
      //   width: 50,
      //   renderCell: (params) => {
      //     console.log(params?.row) 
      //     return (
      //       <MuiTooltip title="Clone Template" placement="right">

      //         <IconButton onClick={() => {
      //           setPreviewEmail(true)
      //           dispatch(rowSelect([params?.row]))
      //         }} sx={{ p: 0 }}>
      //           <FileCopyIcon color="primary" />
      //         </IconButton>

      //       </MuiTooltip>
      //     );
      //   },
      // },


    ],
  };

  // download template function
  // const handleDownloadTempleteConfig = () => {
  //   dispatch(downloadAssessmentTemplete()).then((res) => {
  //     if (res?.payload?.data?.error) {
  //       setTimeout(() => {
  //         dispatch(resetErrMessage());
  //       }, 2000);
  //     }
  //   });
  // };


  //create method for creating the email template

  const formik = useFormik({
    reset: true,
    initialValues: {
      assessmentType: assessmentType,
      templateCategory: "",
      standardTemplate: "",
      custName: null,
      account: null,
      frameworkName: "",
      templateDisplayName: "",
      templateType: "example one",
      description: "",
      comments: "",
    },

    validationSchema: validationSchema,
    onSubmit: async (values, onSubmitProps) => {
      const res = await dispatch(
        createEmailAssessmentTemplate({
          // assessmentTypeId: values?.assessmentType?.id,

          assessmentCustomerId: values?.custName?.id,
          assessmentCustomerAccountId: values?.account?.id,
          masterTemplateId: values?.standardTemplate?.masterTemplateId,
          templateCategory: values.templateCategory?.name,
          // assessmentTemplateDisplayName: values.templateDisplayName,

          description: values.description,

          // comments: values.comments,
        })
      ).then((res) => {
        if (res?.payload?.data?.ok) {
          setTimeout(() => {
            dispatch(resetMessage());
            closeModel();

              selectedCustValue && !selectedAccountValue ?
                dispatch(getEmailAssessmentTemplateByCustomerAccounts({ assessmentCustomerId: selectedCustValue?.id }))
                : selectedAccountValue
                  ? dispatch(getEmailAssessmentTemplateByCustomerAccounts({ assessmentCustomerId: selectedCustValue?.id, assessmentCustomerAccountId: selectedAccountValue?.id }))
                  : dispatch(getAssessmentEmailTemplate());



            onSubmitProps.resetForm();
          }, 2000);
          return true;
        }
        if (res?.payload?.error) {
          setTimeout(() => {
            dispatch(resetErrMessage());
          }, 3000);
        }
        return false;
      });
      return res;
    },
  });

  //update method for for updating the email template

  const formikEdit = useFormik({
    enableReinitialize: true,
    initialValues: {
      custName: selectedData?.assessmentCustomer?.id,
      accountName: selectedData?.assessmentCustomerAccount?.id,
      templateCategory: selectedData?.masterTemplate?.emailCategory,
      standardTemplate: selectedData?.masterTemplate,
      // templateDisplayName: selectedData?.assessmentTemplateDisplayName,

      description: selectedData?.description,
      status: selectedData?.status,

    },

    validationSchema: editValidationSchema,
    onSubmit: async (values) => {
      const res = await dispatch(
        updateEmailUpdateTemplate({
          id: selectedData?.id,
          masterTemplateId: selectedData?.masterTemplate?.masterTemplateId,

          // assessmentTemplateDisplayName: values.templateDisplayName,
          description: values.description,
          status: values?.status,

        })
      ).then((res) => {
        if (res?.payload?.data?.ok) {
          setTimeout(() => {
            dispatch(resetMessage());
            closeEditModal();
            selectedCustValue && !selectedAccountValue ?
                dispatch(getEmailAssessmentTemplateByCustomerAccounts({ assessmentCustomerId: selectedCustValue?.id }))
                : selectedAccountValue
                  ? dispatch(getEmailAssessmentTemplateByCustomerAccounts({ assessmentCustomerId: selectedCustValue?.id, assessmentCustomerAccountId: selectedAccountValue?.id }))
                  : dispatch(getAssessmentEmailTemplate());
          }, 2000);
          return true;
        }
        if (res?.payload?.error) {
          setTimeout(() => {
            dispatch(resetErrMessage());
          }, 3000);
        }
        return false;
      });
      return res;
    },
  });

  //get accounts useing customer Id

  useEffect(() => {
    if (formik.values?.custName?.id) {
      dispatch(getAccountById({ assessmentCustomerId: formik.values?.custName?.id }))
    }

  }, [formik.values?.custName])

  // console.log(formikEdit?.values?.accountName)

  //Intial display of data

  useEffect(() => {

    dispatch(getPlatformStatus());
    dispatch(getTemplateType());
    dispatch(getAccount())
    dispatch(getCustomer())
    dispatch(getassessmentType())
    dispatch(getassessmentEmailType());
    // dispatch(getAssessmentEmailTemplate())
  }, [])


  //setting the value for selected Template category

  useEffect(() => {
    formik?.setFieldValue("templateCategory", !assessmentCategory ? assessmentTypes?.find((data) => data.name === "ELI Assessment") : assessmentCategory)

    // setAssessmentType(assessmentType ? assessmentType : assessmentTypeData?.find((data) => data.code === "ELI"))
  }, [assessmentTypes, assessmentCategory]);





  // useEffect(() => {
  //   dispatch(setAssessmentType(assessmentTypeData?.find((data) => data.code === "ELI")));
  // }, [assessmentTypeData])



  useEffect(() => {
    // if assessment type is selected no need to call this use effect then the state variable it wont change so that time 
    // you will get the state variable stored and it will not be resetted everytime
    if (assessmentTypes?.length > 0) {
      const defaultType = assessmentTypes.find(
        (data) => data.name === "ELI Assessment"
      );

      if (defaultType) {
        setAssessmentCategory(defaultType);
        formik.setFieldValue("templateCategory", defaultType);
      }
    }
  }, [assessmentTypes]);
  // resetting the assessment type data if the component unmounts and resetting the ELI Assessment
  // useEffect(() => {
  //   return() =>{
  //       console.log("This conditon it is executing")
  //     dispatch(setAssessmentType(null));
  //   };
  // },[])

  // console.log("assessmentype",assessmentType)
  // console.log("Formik",formik)
  let shrink = props.sidebar ? "scale" : "no-scale";

  // console.log(formik?.values?.assessmentType)

  //handle submit for update and create
  const handleSubmit = async () => {
    if (showAdd2) {
      const result = await formik.submitForm();
      return result;
    } else if (showEdit) {
      const result = await formikEdit.submitForm();
      return result;
    }
  };

  const htmlContent =
    typeof selectedData?.blocksJson === "string"
      ? JSON.parse(selectedData.blocksJson)?.html
      : selectedData?.blocksJson?.html;



  // const htmlContent = selectedData?.blocksJson
  //   ? JSON.parse(selectedData.blocksJson)?.design?.body?.rows
  //     ?.flatMap((row) => row.columns || [])
  //     ?.flatMap((column) => column.contents || [])
  //     ?.map((content) => content?.values?.text || "")
  //     ?.join("") || ""
  //   : "";

  let cleanedHtml = htmlContent?.replace(/\{\{([^}]+)\}\}/g, "$1")
    .replace(/<p>(&nbsp;|\s)*<\/p>/gi, "");

  //replace the key with sample

  selectedData?.masterTemplate?.params.forEach((params) => {
    const regex = params.sample

    cleanedHtml = cleanedHtml?.replaceAll(params?.key, regex);
  });


  const parser = new DOMParser();
  const doc = parser.parseFromString(cleanedHtml, "text/html");

  // Get subject text
  const allParagraphs = doc.querySelectorAll("p");



  allParagraphs.forEach((p) => {
    const text = p.textContent?.trim();

    if (text?.startsWith("Subject:")) {
      p.style.removeProperty('display')
    }
  });
  cleanedHtml = doc.body.innerHTML;

  console.log(cleanedHtml)




  //

  const onPreviewClick = () => {
    const editor = emailEditorRef.current?.editor;


    const subject = selectedData?.masterTemplate?.subject || "";
    const subjectStyle = `
      text-align:center;
      font-size:16px;
      font-family:Arial,sans-serif;
      font-weight:bold;
      margin:0;`;

    const subjectContent = `
  <p style="${subjectStyle}">
    Subject: ${subject}
  </p>
     `


    editor.saveDesign((design) => {
      const textBlock =
        design.body.rows[0].columns[0].contents[1];

      textBlock.values.text = textBlock.values.text
        .replace(
          /margin:\s*30px 0px;?/gi,
          "margin:0;"
        )
        .replace(
          /margin:\s*20px 0px;?/gi,
          "margin:0;"
        );

      editor.loadDesign(design);
      setHtmlPreview(true)

      setTimeout(() => {
        editor.showPreview("desktop");
      }, 500);
    });
  }

  const subject = selectedData?.masterTemplate?.subject || "";
  const subjectStyle = `
      text-align:center;
      font-size:16px;
      font-family:Arial,sans-serif;
      font-weight:bold;
      margin:0;`;

  const subjectContent = `
  <p style="${subjectStyle}">
    Subject: ${subject}
  </p>`




  return (
    <>
      <>
        {/* <Stack flexDirection="row" justifyContent="space-between">
          <Box sx={{ width: "100%" }}>
            <PageHeader variant="pageHeader">
              Assessment Framework
            </PageHeader>
          </Box>
         
        </Stack> */}





        <HeaderDropDown name="Template category" heading="Custom Email Templates" assessmentTypeData={assessmentTypes} assessmentType={assessmentCategory} setAssessmentType={(value) => setAssessmentCategory(value)} />

        {/* <PageHeader
          variant="pageHeader"
          pathname="/exco/platform/config"
          moduleName={props?.location?.moduleName}
          data={props?.location?.data}
        >
          Assessment Template
        </PageHeader> */}
        <MuiDataGrid
          setShowAdd={
            // location?.state?.permissions?.find((e) => e.applicationService?.name?.split(".")[e?.applicationService?.name?.split(".")?.length - 1] === "createAssessTemp") &&
            showAddModel
          }
          setShowEdit={
            // location?.state?.permissions?.find((e) => e.applicationService?.name?.split(".")[e?.applicationService?.name?.split(".")?.length - 1] === "updateAssessTemp") &&
            showEditModal
          }
          setShowDelete={
            // location?.state?.permissions?.find((e) => e.applicationService?.name?.split(".")[e?.applicationService?.name?.split(".")?.length - 1] === "deleteAssessTemp") &&
            showDelete
          }
          // sending this props to reset the seelcted customer and account if the user changes the assessment type
          // assessmentType={assessmentType}
          isAccount={true}
          isCustomer={true}
          getAccountSelectedValue={(data) => getAccountSelectedValue(data)}
          getCustomerSelectedValue={(data) => getCustomerSelectedValue(data)}
          // setShowAdd={
          //   location?.serviceAccessData?.userRoleL3ServicePermission?.length >
          //     0 &&
          //   location?.serviceAccessData?.userRoleL3ServicePermission?.find(
          //     (e) =>
          //       e.applicationService?.name?.split(".")[
          //         e?.applicationService?.name?.split(".")?.length - 1
          //       ] === "createAssessTemp"
          //   ) &&
          //   showAddModel
          // }
          // setShowEdit={
          //   location?.serviceAccessData?.userRoleL3ServicePermission?.length >
          //     0 &&
          //   location?.serviceAccessData?.userRoleL3ServicePermission?.find(
          //     (e) =>
          //       e.applicationService?.name?.split(".")[
          //         e?.applicationService?.name?.split(".")?.length - 1
          //       ] === "updateAssessTemp"
          //   ) &&
          //   showEditModal
          // }
          // setShowDelete={
          //   location?.serviceAccessData?.userRoleL3ServicePermission?.length >
          //     0 &&
          //   location?.serviceAccessData?.userRoleL3ServicePermission?.find(
          //     (e) =>
          //       e.applicationService?.name?.split(".")[
          //         e?.applicationService?.name?.split(".")?.length - 1
          //       ] === "deleteAssessTemp"
          //   ) &&
          //   showDelete
          // }
          toolbarColumn={true}
          // toolbarFilter={true}
          toolbarDensity={true}
          toolbarExport={true}
          toolbarUpload={true}
          // handleUpload={handleFile}
          toolbarPageObjectDownload={true}
          // handlePageObjectDownload={handleDownloadTempleteConfig}
          data={data}
          select={(data) => dispatch(rowSelect(data))}
          getCallBackOne={getAssessmentEmailTemplate}
          getCallBackCustomer={(data) => getEmailAssessmentTemplateByCustomerAccounts({ assessmentCustomerId: data, assessmentCustomerAccountId: selectedAccountDataList?.id ? selectedAccountDataList?.id : null })}
          getCallBackTwo={(data) =>
            getEmailAssessmentTemplateByCustomerAccounts({ assessmentCustomerId: selectedCustomerDataList?.id, assessmentCustomerAccountId: data })}

          projCheck={false}
        />
      </>


      {/* <ModalPopUp
        open={showAdd2}
        handleClose={closeModel}
        closeModel={closeModel}
      >
        <Box
       
          className={classes.rootbox}
          component="form"
          noValidate
          onSubmit={formik.handleSubmit}
        >
          <PageHeader>Add Assessment Framework</PageHeader>
          <ModalCloseBtn close={closeModel} />
          <div className={classes.responsive_text}> */}


      {showAdd2 && <CommonCurdPopUp
        heading="Add Email Template"
        mediumScreen={true}
        close={closeModel}
        handleSubmit={handleSubmit}
        loading={loading}
      >
        <Grid container >
          <Grid item xs={12} sm={12} md={0.5} lg={0.5}></Grid>
          <Grid item xs={12} sm={12} md={11} lg={11}>

            <MuiAutocomplete
              // disabled
              name="templateCategory"
              options={assessmentTypes}
              setValue={(name, newValue) => {

                formik.setFieldValue(name, newValue)

              }
              }

              value={formik.values.templateCategory}
              optionValue="name"
              // optionSecValue="code"
              label="Template Category"
              required={true}
              error={formik.touched.templateCategory && Boolean(formik.errors.templateCategory)}
              helperText={formik.touched.templateCategory && formik.errors.templateCategory}
            />

            <MuiAutocomplete
              name="custName"
              options={customersData}
              setValue={(name, newValue) => {

                formik.setFieldValue(name, newValue)
                formik.setFieldValue("account", "")
                formik.setFieldValue("assessment", "")
                formik.setFieldValue("templateDisplayName", "")
                formik.setFieldValue("client", "");
              }
              }

              value={formik.values.custName}
              optionValue="customerName"
              label="Customer"
              required={true}
              error={formik.touched.custName && Boolean(formik.errors.custName)}
              helperText={formik.touched.custName && formik.errors.custName}
            />

            <MuiAutocomplete
              name="account"
              options={formik.values.custName ? accountIdData : []}
              setValue={(name, newValue) => {
                formik.setFieldValue(name, newValue)
                formik.setFieldValue("assessment", "");
                formik.setFieldValue("templateDisplayName", "");
                formik.setFieldValue("client", "");
              }

              }

              value={formik.values.account}
              optionValue="accountName"
              // optionSecValue="accountName"
              label="Account Name"
              required={true}
              error={
                formik.touched.account && Boolean(formik.errors.account)
              }
              helperText={formik.touched.account && formik.errors.account}
            />

            <MuiAutocomplete
              // disabled
              name="standardTemplate"
              options={
                (assessmentEmailData ?? []).filter((data) => {
                  const category = formik?.values?.templateCategory?.name?.toLowerCase();
                  const emailCategory = data?.emailCategory?.toLowerCase();

                  return (
                    data?.status === "active" &&
                    category &&
                    emailCategory?.includes(category)
                  );
                })
              }
              setValue={(name, newValue) => {

                formik.setFieldValue(name, newValue)

              }
              }

              value={formik?.values?.standardTemplate}
              optionValue="templateName"
              // optionSecValue="code"
              label="Default Template"
              required={true}
              error={formik.touched.standardTemplate && Boolean(formik.errors.standardTemplate)}
              helperText={formik.touched.standardTemplate && formik.errors.standardTemplate}
            />

            {/* <MyTextInput
              label="Standard Template"
              type="text"
              name="frameworkName"
              required={true}
              fullWidth={true}
              margin="normal"
              id="frameworkName"
              value={formik.values.frameworkName}
              onChange={formik.handleChange}
              tabIndex={1}
              error={
                formik.touched.frameworkName &&
                Boolean(formik.errors.frameworkName)
              }
              helperText={
                formik.touched.frameworkName && formik.errors.frameworkName
              }
            /> */}
            {/* <MyTextInput
                  label="Display Name"
                  type="text"
                  name="templateDisplayName"
                  required={true}
                  fullWidth={true}
                  margin="normal"
                  id="templateDisplayName"
                  value={formik.values.templateDisplayName}
                  onChange={formik.handleChange}
                  tabIndex={1}
                  error={
                    formik.touched.templateDisplayName &&
                    Boolean(formik.errors.templateDisplayName)
                  }
                  helperText={
                    formik.touched.templateDisplayName &&
                    formik.errors.templateDisplayName
                  }
                /> */}

            <MyTextInput
              label="Comments"
              type="text"
              name="description"
              // required={true}
              fullWidth={true}
              margin="normal"
              id="description"
              value={formik.values.description}
              onChange={formik.handleChange}
              // multiline={true}
              // rows={4}
              error={
                formik.touched.description &&
                Boolean(formik.errors.description)
              }
              helperText={
                formik.touched.description && formik.errors.description
              }
            />

            {/* <Box style={{ width: "100%", textAlign: "center" }} mt={2}>

              <FormSubmitButton onClick={formik?.handleSubmit} type="submit" variant="contained">
                Submit
              </FormSubmitButton>
            </Box> */}

            {/* <MyTextInput
                  label="Comment"
                  type="text"
                  name="comments"
                  required={true}
                  fullWidth={true}
                  margin="normal"
                  id="comments"
                  value={formik.values.comments}
                  onChange={formik.handleChange}
                  multiline={true}
                  rows={4}
                  error={
                    formik.touched.comments &&
                    Boolean(formik.errors.comments)
                  }
                  helperText={
                    formik.touched.comments && formik.errors.comments
                  }
                /> */}
          </Grid>
        </Grid>

      </CommonCurdPopUp>}

      {/* {previewEmailTemplate && <CommonCurdPopUp
        heading="Edit Email Template"
        mediumScreen={true}
        close={()=>setPreviewEmailTemplate(false)}
        handleSubmit={handleSubmit}
        loading={loading}
      >




      

      </CommonCurdPopUp>} */}

      <Dialog
        open={previewEmailTemplate}
        onClose={() => setPreviewEmailTemplate(false)}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            height: "95vh",
            width: "80vw !important",
            maxWidth: "none",
          },
        }}
      >
        {/* HEADER */}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
          padding={2}
          borderBottom="1px solid #ddd"
          position="relative"
        >
          <Typography
            variant="h5"
            fontWeight={700}
            sx={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
            }}
          >
            Edit Email Template
          </Typography>

          <Box display="flex" gap={2}>
            <Button
              variant="contained"
              onClick={onPreviewClick
                // () => {
                //   setHtmlPreview(true)
                //   emailEditorRef.current?.editor?.showPreview("desktop")
                // }

              }
            >
              Preview
            </Button>

            <Button
              variant="contained"
              color="success"
              onClick={saveDesign}
            >
              Save
            </Button>
            <MuiTooltip title="close">
              <IconButton  aria-label="cancel" onClick={() => setPreviewEmailTemplate(false)}>
                <CancelIcon color="red" />
              </IconButton>
            </MuiTooltip>
          </Box>
        </Box>
        {!htmlPreview && <Box>
          <Alert
            severity="info"
            icon={<InfoOutlinedIcon />}
            sx={{
              borderRadius: 2,
              "& .MuiAlert-message": {
                width: "100%",
              },
            }}
          >
            {/* <AlertTitle sx={{ fontWeight: 600 }}>
              Dynamic Values (Placeholders)
            </AlertTitle> */}

            Highlighted dynamic values are automatically populated when the email is sent. Please do not edit or remove them.

            <Box
              sx={{
                mt: 0.3,
                display: "flex",
                gap: 1,
                flexWrap: "wrap",
              }}
            >
              {selectedData?.masterTemplate?.params?.map((param) => (
                <Chip

                  key={param.key}
                  label={`${param.sample}`}
                  size="small"
                  color="primary"
                  variant="outlined"
                />
              ))}
            </Box>
          </Alert>
        </Box>}

        {/* EMAIL EDITOR */}
        <DialogContent
          sx={{

            overflow: "hidden",
            height: "100vh",
            p: 0,

            "& .blockbuilder-tools-panel": {
              width: "30% !important",
              minWidth: "300px",
            },

            "& .blockbuilder-stage": {
              width: "70% !important",
            },
          }}
        >


          <EmailEditor
            ref={emailEditorRef}

            options={{
              displayMode: "email",
              tools: {
                social: {
                  enabled: false,
                },
                menu: {
                  enabled: false,
                },
                html: {
                  enabled: false,
                },
              },
              features: {
                preview: false, // Disable preview mode
              },
              appearance: {
                panels: {
                  tools: {
                    dock: "right",
                  },
                },
              },
            }}
            onLoad={onLoad}
            minHeight="100%"
          />
        </DialogContent>
      </Dialog>

      {/* HTML PREVIEW */}
      {/* {htmlPreview && (
        <Dialog
          open={Boolean(htmlPreview)}
          onClose={() => setHtmlPreview(null)}
          fullWidth
          maxWidth="md"
        >

          <Box
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
            padding={2}
            borderBottom="1px solid #ddd"
            position="relative"
          >
            <Typography variant="h5"
              fontWeight={700} sx={{
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
                fontSize: "1.5rem"
              }} variant="h6">
              Email Preview
            </Typography>

            <MuiTooltip title="close">
              <IconButton aria-label="cancel" onClick={() => setHtmlPreview("")}>
                <CancelIcon color="red" />
              </IconButton>
            </MuiTooltip>


          </Box>

          <DialogContent

          >
            <iframe
              title="preview"
              style={{
                width: "100%",
                height: "70vh",
                border: "none",
              }}
              srcDoc={htmlPreview}
            />
          </DialogContent>
        </Dialog>
      )} */}

      {/* </div>

     
        </Box>
      </ModalPopUp> */}

      {/* <FormSubmitButton type="submit" variant="contained">
            Submit
          </FormSubmitButton> */}



      {/* <ModalPopUp
        open={showEdit}
        handleClose={() => setShowEdit(false)}
        closeModel={() => setShowEdit(false)}
      >
        <Box
         
          className={classes.rootbox}
          component="form"
          noValidate
          onSubmit={formikEdit.handleSubmit}
        >
          <PageHeader>Update Assessment Framework</PageHeader>
          <ModalCloseBtn close={() => setShowEdit(false)} />
          <div className={classes.responsive_text}> */}
      {showEdit && <CommonCurdPopUp
        heading="Update Email Template"
        mediumScreen={true}
        close={
          () => {

            setShowEdit(false)
            formikEdit.resetForm({
              values: {
                frameworkName: "",
                description: "",
                comments: "",
                comments: ""
              },
            });

          }
        }
        handleSubmit={handleSubmit}
        loading={loading}
      >
        <Grid container>
          <Grid item xs={12} sm={12} md={0.5} lg={0.5}></Grid>
          <Grid item xs={12} sm={12} md={11}>
            <FormControl sx={{ marginTop: "1rem" }} fullWidth>
              <InputLabel id="demo-simple-select-label">
                Template Category
              </InputLabel>
              <Select
                disabled
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="templateCategory"
                defaultValue={formikEdit.values.templateCategory}
                value={formikEdit.values.assessmentType}
                label="Template Category"
                onChange={formikEdit.handleChange}
                error={
                  formikEdit.touched.templateCategory &&
                  Boolean(formikEdit.errors.templateCategory)
                }
              >
                {assessmentTypes?.map((option) => {
                  return (
                    <MenuItem
                      key={option.id}
                      value={option.name}
                    >
                      {option.name}
                    </MenuItem>
                  );
                })}
              </Select>
              <FormHelperText error={true} sx={{ color: "red" }}>
                {formikEdit.touched.accountName && formikEdit.errors.accountName}
              </FormHelperText>
            </FormControl>

            <FormControl sx={{ marginTop: "1rem" }} fullWidth>
              <InputLabel id="demo-simple-select-label">
                Customer *
              </InputLabel>
              <Select
                disabled
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="custName"
                defaultValue={formikEdit.values.custName}
                value={formikEdit.values.custName}
                label="Customer"
                onChange={formikEdit.handleChange}
                error={
                  formikEdit.touched.custName &&
                  Boolean(formikEdit.errors.custName)
                }
              >
                {customersData.map((option) => {
                  return (
                    <MenuItem
                      key={option.id}
                      value={option.id}
                    >
                      {option.customerName}
                    </MenuItem>
                  );
                })}
              </Select>
              <FormHelperText error={true} sx={{ color: "red" }}>
                {formikEdit.touched.custName && formikEdit.errors.custName}
              </FormHelperText>
            </FormControl>

            <FormControl sx={{ marginTop: "1rem" }} fullWidth>
              <InputLabel id="demo-simple-select-label">
                Accounts *
              </InputLabel>
              <Select
                disabled
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="accountName"
                defaultValue={formikEdit.values.accountName}
                value={formikEdit.values.accountName}
                label="Accounts"
                onChange={formikEdit.handleChange}
                error={
                  formikEdit.touched.accountName &&
                  Boolean(formikEdit.errors.accountName)
                }
              >
                {accountData?.map((option) => {
                  return (
                    <MenuItem
                      key={option.id}
                      value={option.id}
                    >
                      {option.accountName}
                    </MenuItem>
                  );
                })}
              </Select>
              <FormHelperText error={true} sx={{ color: "red" }}>
                {formikEdit.touched.accountName && formikEdit.errors.accountName}
              </FormHelperText>
            </FormControl>



            <MuiAutocomplete
              disabled
              name="standardTemplate"
              options={assessmentEmailData?.length > 0 ? assessmentEmailData?.filter((data) => data.masterTemplate?.isActive === true) : []}
              setValue={(name, newValue) => {

                formikEdit.setFieldValue(name, newValue)

              }
              }

              value={formikEdit?.values?.standardTemplate}
              optionValue="templateName"
              // optionSecValue="code"
              label="Default Template"
              required={true}
              error={formikEdit.touched.standardTemplate && Boolean(formikEdit.errors.standardTemplate)}
              helperText={formikEdit.touched.standardTemplate && formikEdit.errors.standardTemplate}
            />

            {/* <MyTextInput
                  label="Display Name"
                  type="text"
                  name="templateDisplayName"
                  required={true}
                  fullWidth={true}
                  margin="normal"
                  id="templateDisplayName"
                  defaultValue={formikEdit.values.templateDisplayName}
                  value={formikEdit.values.templateDisplayName}
                  onChange={formikEdit.handleChange}
                  error={
                    formikEdit.touched.templateDisplayName &&
                    Boolean(formikEdit.errors.templateDisplayName)
                  }
                  helperText={
                    formikEdit.touched.templateDisplayName &&
                    formikEdit.errors.templateDisplayName
                  }
                /> */}
            <FormControl sx={{ marginTop: "1rem" }} fullWidth>
              <InputLabel id="demo-simple-select-label">
                Template Status *
              </InputLabel>
              <Select
                required={true}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="status"
                defaultValue={formikEdit.values.status}
                value={formikEdit.values.status}
                label="Template Status"
                onChange={formikEdit.handleChange}
                error={
                  formikEdit.touched.status &&
                  Boolean(formikEdit.errors.status)
                }
              >
                {assessmentTemplateStatusData.map((option) => {
                  return (
                    <MenuItem key={option.id} value={option.
                      assessmentTemplateStatus}>
                      {option.
                        assessmentTemplateStatus}
                    </MenuItem>
                  );
                })}
              </Select>
              <FormHelperText error={true} sx={{ color: "red" }}>
                {formikEdit.touched.status && formikEdit.errors.status}
              </FormHelperText>
            </FormControl>


            <MyTextInput
              label="Comments"
              type="text"
              name="description"
              fullWidth={true}
              // required={true}
              margin="normal"
              id="description"
              value={formikEdit.values.description}
              onChange={formikEdit.handleChange}
              // multiline={true}
              // rows={4}
              error={
                formikEdit.touched.description &&
                Boolean(formikEdit.errors.description)
              }
              helperText={
                formikEdit.touched.description &&
                formikEdit.errors.description
              }
            />
            {/* <MyTextInput
                  label="Comment"
                  type="text"
                  name="comments"
                  required={true}
                  fullWidth={true}
                  margin="normal"
                  id="comments"
                  value={formik.values.comments}
                  onChange={formik.handleChange}
                  multiline={true}
                  rows={4}
                  error={
                    formik.touched.comments &&
                    Boolean(formik.errors.comments)
                  }
                  helperText={
                    formik.touched.comments && formik.errors.comments
                  }
                /> */}

            {/* <Box style={{ width: "100%", textAlign: "center" }} >

              <FormSubmitButton onClick={formikEdit?.handleSubmit} type="submit" variant="contained">
                Submit
              </FormSubmitButton>
            </Box> */}
          </Grid>
        </Grid>


      </CommonCurdPopUp>}

      {previewEmail && <CommonCurdPopUp

        smallScreen={true}
        close={
          () => setPreviewEmail(false)
        }
        heading="Email Preview"

      >


        {/* <h5 className="center bold pt-2 header-font-size">Email Preview</h5> */}
        <div

          dangerouslySetInnerHTML={{
            __html:
              cleanedHtml && cleanedHtml !== "undefined"
                ? cleanedHtml
                : `${subjectContent}${selectedData?.masterTemplate?.preview || ""}`,
          }}
        />




      </CommonCurdPopUp>}

      {/* </div> */}

      {/* <FormSubmitButton type="submit" variant="contained">
        Submit
      </FormSubmitButton> */}
      {/* </Box>
      </ModalPopUp> */}

      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={(obj) => handleSetConfirmDialog(obj)}
      />

      {/* < MicrositeConfirmDialog
        confirmDialog={forceDelConfirmDialog}
        setConfirmDialog={(obj) => handleSetForceDelConfirmDialog(obj)}
      /> */}
      {errMessage && <ErrorNotifier message={errMessage} />}
      {message && <Notifier message={message} />}
    </>
  );
};

export default AssessmentTemplateConfig;
